import React, { ComponentProps } from 'react';

import { View } from './View';

type Props = Omit<ComponentProps<typeof View>, 'className'>;

export function HiddenPrintView(props: Props) {
  return <View className="hidden-print" {...props} />;
}
